import { useTranslation } from 'react-i18next'

import { ChatDotsIcon } from '@phosphor-icons/react'

import {
  Alert,
  Button,
  ButtonWithSpinner,
  CardTitle,
  Drawer,
  InputWithLabel,
  StoreCreditIcon,
  Switch,
  Text,
} from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const CancelStoreCreditDrawer = ({
  show,
  onClose,
  onCancelStoreCredit,
  cancellingStoreCredit,
  allowIssueOpmOnCancel,
  notes,
  setNotes,
  issueOriginalPaymentMethod,
  setIssueOriginalPaymentMethod,
}) => {
  const { t } = useTranslation()

  return (
    <Drawer show={show} onClose={onClose} options={{ showHeaderActions: false }}>
      <CardTitle Icon={StoreCreditIcon}>{t('Anular crédito en tienda')}</CardTitle>
      <Styles.MainContainer>
        <Text type="bodyMRegular">
          {t(
            'Esta operación anulará el cupón anteriormente emitido. El cliente ya no podrá utilizarlo para realizar una nueva compra.'
          )}
        </Text>
        <InputWithLabel
          fullWidth
          label={t('Notas')}
          value={notes}
          onChange={e => setNotes(e.target.value)}
          Icon={ChatDotsIcon}
          maxLength="500"
          showCounter
        />
        {allowIssueOpmOnCancel && (
          <Switch
            checked={issueOriginalPaymentMethod}
            onChange={e => setIssueOriginalPaymentMethod(e.target.checked)}
            label={t('Emitir reembolso equivalente al Método de pago original')}
          />
        )}
        <Alert type="warning">{t('Esta acción no se podrá deshacer más adelante. ¿Quieres continuar?')}</Alert>
        <Styles.ButtonsContainer>
          <Button fullWidth variant="outlined" onClick={onClose}>
            {t('Cancelar')}
          </Button>
          <ButtonWithSpinner
            fullWidth
            defaultLabel={t('Anular crédito')}
            loadingLabel={t('Anulando crédito')}
            onClick={onCancelStoreCredit}
            loading={cancellingStoreCredit}
            disabled={cancellingStoreCredit || !notes}
          />
        </Styles.ButtonsContainer>
      </Styles.MainContainer>
    </Drawer>
  )
}

export default CancelStoreCreditDrawer
